module.exports = __webpack_public_path__ + "img/icon-128x128.7207db42.png";